import React from 'react';
import FindPatientForm from './FindPatientForm';
import Page from 'App/components/Page';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';
import { useLocation } from 'react-router-dom';

const FindPatient = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const firstName = searchParams.get('firstName');
    const lastName = searchParams.get('lastName');
    const id = searchParams.get('id');
    const phoneNumber = searchParams.get('phoneNumber');
    return (
        <Page title="Find Patient" permissionType={PERMISSION_TYPES.FIND_PATIENT} showPageTitle={false}>
            <div className="container page-wrapper">
                <FindPatientForm
                    paramFirstName={firstName}
                    paramLastName={lastName}
                    paramId={id}
                    paramPhoneNumber={phoneNumber}
                />
            </div>
        </Page>
    );
};

export default FindPatient;
